import enLocale from '../config/translations/en.translations.json'
import intl from 'react-intl-universal'

const LOCALES = {
  'en-US': enLocale,
  'en': enLocale,
  'en-UK': enLocale,
  'en-GB': enLocale,
}

const Init = () => {

  intl.init({
    currentLocale: Object.keys(LOCALES).includes(window.navigator.language) ? window.navigator.language : 'en',
    locales: LOCALES,
  })

  return null
}

export default Init